import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface LogoProps {
  width?: string;
  height?: string;
  textSize?: string;
  showText?: boolean;
  className?: string;
  linkTo?: string;
}

const Logo: React.FC<LogoProps> = ({ 
  width = "w-8", 
  height = "h-8", 
  textSize = "text-xl",
  showText = true,
  className = "",
  linkTo = "/"
}) => {
  const { t } = useTranslation();
  
  const logoContent = (
    <span className={`inline-flex items-center ${className} align-bottom`}>
      <img 
        src="/A-LOGO.svg" 
        alt={t('institutional.header.logoAlt')} 
        className={`${width} ${height}`} 
      />
      {showText && (
        <span className={`bg-gradient-to-r from-electric-teal to-electric-teal-alt bg-clip-text text-transparent font-bold ${textSize}`}>
          {t('institutional.header.brandSuffix')}
        </span>
      )}
    </span>
  );

  if (linkTo) {
    return (
      <Link to={linkTo} className="hover:opacity-80 transition-opacity duration-200">
        {logoContent}
      </Link>
    );
  }

  return logoContent;
};

export default Logo;
